import { ApiProperty } from "@nestjs/swagger";

export class DailySheetData{
    
    @ApiProperty()
    dailySheetdate?:string;

    @ApiProperty()
    fromDate ?:string;

    @ApiProperty()
    toDate ?:string;
   

    constructor(
      dailySheetdate?:string,
      fromDate ?:string,
      toDate ?:string,
    ){
      this.dailySheetdate=dailySheetdate
      this.fromDate=fromDate
      this.toDate=toDate
      

    }

  }